import React from 'react'
import Navbar from './components/Navbar'
import Coins from './components/Coins'
import Trending from './components/Trending'
import Exchange from './components/Exchange'
import News from './components/News'
import Search from './components/Search'
import {
    BrowserRouter as Router,
    Routes,
    Route
} from "react-router-dom";
import Home from './components/Home'


function App() {
    return (
        <div>

            <Router>
                <Routes>
                    <Route exact path="/" element={<Home />}></Route>
                    <Route exact path="/coins" element={<><Navbar /><Trending /><Coins /></>}>  </Route>
                    <Route exact path="/exchange" element={<><Navbar /><Exchange /></>}>  </Route>
                    <Route exact path="/News" element={<><Navbar /><News /></>}>  </Route>
                </Routes>

            </Router>

        </div>




    )
}

export default App